import {Strings} from 'Strings';
import directives from './module';

const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

const createFormatter = (formatterName: string) => {
    directives.directive(formatterName, ['PaymentHelpers', (PaymentHelpers: any) => {
        return {
            scope: false,
            restrict: 'A',
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery) => PaymentHelpers[formatterName](element)
        };
    }]);
};

createFormatter('formatCardNumber');
createFormatter('formatCardExpiry');
createFormatter('formatCardCvc');
createFormatter('restrictNumeric');

interface BlurModelController extends ng.INgModelController {
    isValid: boolean;
}
const createBlurValidator = (validatorName: string, validate?: any, parserCallback?: Function) =>
    directives.directive(validatorName, ['$timeout', 'PaymentHelpers', ($timeout: ng.ITimeoutService, PaymentHelpers: any) => {
        if (PaymentHelpers[validatorName]) {
            validate = PaymentHelpers[validatorName];
        }
        return {
            require: 'ngModel',
            link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: BlurModelController) {
                let isValid = true;
                const parser = (viewValue?: string) => {
                    if (parserCallback) parserCallback(scope, viewValue, PaymentHelpers);
                    isValid = validate(viewValue);
                    if (isValid) {
                        ctrl.$setValidity(validatorName, true);
                        if (ctrl.isValid) element.addClass('is-valid');
                    } else {
                        element.removeClass('is-valid');
                    }
                    ctrl.isValid = ctrl.$valid && isValid;
                    return viewValue;
                };
                ctrl.$parsers.unshift(parser);
                element.on('blur', () => {
                    if (!isValid) {
                        scope.$apply(() =>
                            ctrl.$setValidity(validatorName, false));
                    }
                });
                if (attrs[validatorName] === 'onStart') {
                    $timeout(() => {
                        if (ctrl.$viewValue) {
                            parser(ctrl.$viewValue);
                            element.triggerHandler('blur');
                        }
                    });
                }
            }
        };
    }]
);

createBlurValidator('validateName', (str: string) =>
    !angular.isString(str) || str.length < 30 && /^[A-Z.'\- ]*$/.test(str)
);

createBlurValidator('validateCardNumber');

createBlurValidator('validateCardExpiry', angular.noop(), (scope: any, viewValue: string, PaymentHelpers: any) => {
    let cardExpiry = PaymentHelpers.cardExpiryVal(viewValue || '');
    scope.card_exp_month = cardExpiry.month;
    scope.card_exp_year = cardExpiry.year;
});

createBlurValidator('validateCardCvc');

createBlurValidator('validateZip', (value?: string) =>
    !value || value.length === 0 || /^\d{5}(-\d{4})?$/.test(value)
);

createBlurValidator('validateEmailOnblur', (s: string) => !Strings.isBlank(s) && EMAIL_REGEXP.test(s));

createBlurValidator('requiredOnblur', (s: string) => !Strings.isBlank(s));




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/stripeValidatorsDirectives.ts